export const setMessages = (listMessage) => {
    return {
        type: 'LIST_MESSAGE',
        listMessage,
    };
};

export const setMessage = (message) => {
    return {
        type: 'SET_MESSAGE',
        message
    };
};

export const resetFilters = () => {
    return {
        type: 'RESET_FILTER',
    };
};
